module.exports = __webpack_public_path__ + "img/clipboard-x.c57f334a.svg";